import { AUTH_TOKEN, USER_DATA } from "@/constants/storage-type";
import user from "./constants";
export default {
  token: localStorage.getItem(AUTH_TOKEN) || null,
  user: JSON.parse(localStorage.getItem(USER_DATA)) || user,
};
